import get from 'lodash/get';

// 如果字符串str长度不足count，则在左侧补0
function padLeft(str, count) {
    var count0 = count - str.length;
    if (count0 > 0) {
        str = new Array(count0 + 1).join('0') + str;
    }
    return str;
}

function getKC(pn) {
    // KC位于专利号最后，可能是一个字母，或一个字母加一个数字。
    var matched = pn.match(/[a-z]\d?$/i);
    var kc = matched ? matched[0] : '';
    return kc;
}


// 链接模板
let template = {};

function initTpl() {
    const tplLinks = get(window, 'zPREFACE.tplLinks', {});
    template = {
        epo: tplLinks.EPONEW,
        USA: tplLinks.USA,
        USB: tplLinks.USB,
        UST: tplLinks.UST,
        DE: tplLinks.DE,
        EM: tplLinks.EM,
        NO: tplLinks.NO,
        CN: tplLinks.CN,
        CAA: tplLinks.CAA, // patent
        CAB: tplLinks.CAB, // patent
        CAD: tplLinks.CAD, // design
        AU: tplLinks.AU,
        WO: tplLinks.WO,
        inpadoc: tplLinks.INPADOC
    };
}

// 专利公告日在20100331之前，但由于解密公告日在这日期之后，link也是需要带KD。一共65件专利，我抽查检验过，请单独处理下
// 另外，由于解密专利是不定期公开，且根据保密等级，可能会公开20100331之前的专利。
// 所以，针对解密专利更新的SIPO link，我们会不定期提供列表
const EXCEPT_PNS = [
    'CN106342077B',
    'CN106961833B',
    'CN103650659B',
    'CN105122969B',
    'CN106341999B',
    'CN104335706B',
    'CN106342090B',
    'CN104335707B',
    'CN104335708B',
    'CN104335709B',
    'CN106342252B',
    'CN105659796B',
    'CN106134363B',
    'CN106341995B',
    'CN106342070B',
    'CN106342150B',
    'CN105659789B',
    'CN107182251B',
    'CN106134438B',
    'CN105659787B',
    'CN106342071B',
    'CN106342065B',
    'CN105659786B',
    'CN106342015B',
    'CN103748986B',
    'CN105659756B',
    'CN106961834B',
    'CN106342397B',
    'CN106342311B',
    'CN106342172B',
    'CN106342012B',
    'CN105659750B',
    'CN105659812B',
    'CN106342063B',
    'CN105659759B',
    'CN105659871B',
    'CN106342093B',
    'CN106134324B',
    'CN104335705B',
    'CN105659831B',
    'CN105659837B',
    'CN106342034B',
    'CN106342164B',
    'CN102812796B',
    'CN106342168B',
    'CN106342165B',
    'CN106342395B',
    'CN105940777B',
    'CN106342057B',
    'CN106342009B',
    'CN106342394B',
    'CN106342000B',
    'CN106342095B',
    'CN106342278B',
    'CN105659836B',
    'CN106342300B',
    'CN107211575B',
    'CN106341988B',
    'CN106134374B',
    'CN105659872B',
    'CN105659845B',
    'CN105659811B',
    'CN105659844B',
    'CN106342014B',
    'CN106342209B'
];

// 链接文案
const officialNameMap = {
    DE: 'DEPATISnet',
    EM: 'TMDN',
    EU: 'TMDN',
    NO: 'NIPO',
    CN: 'CNIPA',
    CA: 'CAIPO',
    AU: 'AusPat',
    WO: 'WIPO'
};

function funcEMEU (pn) {
    if (/^(EM|EU)(\d{9,9})(\d{4,4})/i.test(pn)) {
        const key = `${RegExp.$2}-${RegExp.$3}`;
        return template.EM.replace(/@key/gi, key);
    }
}

// 链接生成方法
const officialLinkMap = {
    US: function(pn) {
        // USA PN=US＋11位数＋KC(A1/A2/A9/P1)
        if (/^US(\d{11,11})(A1|A2|A9|P1)$/i.test(pn)) {
            return template.USA.replace(/@key/gi, RegExp.$1);
        }
        // USB PN=US+7个数字
        if (/^US(\d{7,8})((A|B|C|E|F|H|I)([0-9]?)|(P[1-9]?))$/i.test(pn)) {
            return template.USB.replace(/@key/gi, RegExp.$1);
        }

        // USB PN=US+R+1-5个数字
        if (/^USRE(\d{1,5})(E|F)[1-3]{0,1}$/i.test(pn)) {
            var key = `RE${padLeft(RegExp.$1, 5)}`;
            return template.USB.replace(/@key/gi, key);
        }
        // USB PN=US+PP+1-5个数字
        if (/^USPP(\d{1,5})[A-Z]\d{0,1}$/i.test(pn)) {
            let key = `PP${padLeft(RegExp.$1, 5)}`;
            return template.USB.replace(/@key/gi, key);
        }
        // USB PN=US+PP+1-6个数字
        if (/^US(D|H|T)(\d{1,6})[A-Z]\d{0,1}$/i.test(pn)) {
            let key = RegExp.$1 + padLeft(RegExp.$2, 6);
            var temp = RegExp.$1 === 'T' ? template.UST : template.USB;
            return temp.replace(/@key/gi, key);
        }
    },
    DE: function(pn) {
        if (/^DE(\d{1,12})([A-Z]\d?)$/i.test(pn)) {
            var key = padLeft(RegExp.$1, 12) + RegExp.$2;
            return template.DE.replace(/@key/gi, key);
        }
    },
    EM: funcEMEU,
    EU: funcEMEU,
    NO: function(pn, apn) {
        // APN=NO+4位年份+3-4位数字
        if (/^NO(\d{7,8})$/i.test(apn)) {
            return template.NO.replace(/@key/gi, RegExp.$1);
        }
    },
    WO: function(pn) {
        // PN=WO+10位数字+KC
        if (/^WO(\d{10,10})([A-Z]\d?)$/i.test(pn)) {
            return template.WO.replace(/@key/gi, RegExp.$1);
        }
    },
    CN: function(pn, apn, pbd) {
        // PN＝CN＋（7-9）位数＋KD
        if (/^CN(\d{7,9})([A-Z]\d?)$/i.test(pn)) {
            const formatPbd = new Date(pbd).getTime();
            const limitPbd = new Date('2010-03-31').getTime();
            if (formatPbd <= limitPbd && EXCEPT_PNS.indexOf(pn) === -1) {
                // CN链接
                // 如专利的公开日在2010.04.07之后（包含当天），参数PN带有KD
                // 如专利的公开日在2010.03.31之前（包含当天），参数PN的KD去掉
                var kc = getKC(pn);
                // 如果以C结尾不做截取
                if (kc !== 'C') {
                    var lastKCIndex = pn.lastIndexOf(kc);
                    pn = lastKCIndex > -1 ? pn.substr(0, lastKCIndex) : pn;
                }
            }
            return template.CN.replace(/@key/gi, pn);
        }
    },
    CA: function(pn, apn, pbd, patentType) {
        // PN＝CA＋7位数＋KD
        // APN＝CA＋7位数
        if (/^CA(\d{5})/i.test(apn)) {
            var kc = getKC(pn);
            pn = pn.replace('CA', '').replace(kc, '');
            var pt = null;
            if (Array.isArray(patentType)) {
                for (var i = 0; i < patentType.length; i++) {
                    if (patentType[i].length === 3) {
                        pt = patentType[i];
                        break;
                    }
                }
            }
            return template[pt] && template[pt].replace(/@key/gi, pn);
        }
    },
    AU: function(pn, apn) {
        // APN＝AU＋10位数
        if (/^AU(\d{10})$/i.test(apn)) {
            return template.AU.replace(/@key/gi, apn.replace('AU', ''));
        }
    }
};

export default {
    initTpl,
    /*
   * 返回某专利在欧专局官网的链接
   * 参数：docdb，不是普通的专利号
   */
    getEspacenetLink: function(docdb, familyId) {
        if (!docdb || !familyId) return null;
        const kc = this.getKC(docdb);
        if (['A0', 'D0', 'P0', 'U0', 'V0'].indexOf(kc) > -1) {
            return null;
        }
        const link = template.epo
            .replace('@fam', familyId)
            .replace(/@pn/g, docdb);
        return {
            name: 'Espacenet',
            link: link
        };
    },
    getOfficialLink: function(pn = '', apn = '', pbd, patentType) {
        pn = pn.toUpperCase();
        apn = apn.toUpperCase();
        var cc = pn.substring(0, 2);
        var name = officialNameMap[cc];
        var link = officialLinkMap[cc] && officialLinkMap[cc](pn, apn, pbd, patentType);
        if (!name || !link) return null;
        return {
            name: officialNameMap[cc],
            link: link
        };
    },
    getKC: function(pn) {
        //   // KC位于专利号最后，可能是一个字母，或一个字母加一个数字。
        // var matched = pn.match(/[a-z]\d?$/i);
        // var kc = matched ? matched[0] : '';
        // return kc;
        return getKC(pn);
    },
    getInpadocLink: function(docdb) {
        if (!docdb) return null;
        var CN = docdb.substr(0, 2);
        var KD = docdb.substr(-2, 2);
        var NB = docdb.substring(2, docdb.length - 2);
        var link = template.inpadoc.replace('@key', [CN, NB, KD].join('.'));
        return {
            name: 'Inpadoc',
            link: link
        };
    }
};
